export const fetchManifest = () => fetch(
    `${manywho.cdnUrl}/flow-library-assets/manifest.json`,
).then(
    response => response.json(),
);
